import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  email: string;
  phone: string;
}

const initialState: UserState = {
  email: "",
  phone: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<{ email: string; phone: string }>) => {
      state.email = action.payload.email;
      state.phone = action.payload.phone;
    },
  },
});

export const { setUserData } = userSlice.actions;
export default userSlice.reducer;
